import React, { useState } from "react";
import { FaAngleDown } from "react-icons/fa";

const items = [
  {
    title: "Phase 1",
    info: "✅ 111,111,111 tokens × $0.0045 = $500,000 target\n🟢 First presale Phase.",
    activedHeight: 120,
  },
  {
    title: "Phase 2",
    info: "✅ 100,000,000 tokens × $0.005 = $500,000 target\n📈 Price increased by 11.11% from Phase 1.",
    activedHeight: 120,
  },
  {
    title: "Phase 3",
    info: "✅ 90,909,091 tokens × $0.0055 = $500,000 target\n📈 Price increased by 10.00% from Phase 2.",
    activedHeight: 120,
  },
  {
    title: "Phase 4",
    info: "✅ 61,538,462 tokens × $0.0065 = $400,000 target\n📈 Price increased by 18.18% from Phase 3.",
    activedHeight: 120,
  },
  {
    title: "Phase 5",
    info: "✅ 14,285,714 tokens × $0.007 = $100,000 target\n📈 Price increased by 7.69% from Phase 4.",
    activedHeight: 120,
  }
];


const Phase = () => {
  const [activeTitle, setActiveTitle] = useState("");

  return (
    <div className="w-[83%] mx-auto mt-14 ">
 <div className="w-full text-center mb-4 ">
  <span className="gradient-text font-semibold text-md md:text-lg text-transparent bg-clip-text bg-gradient-to-r from-pink-300 via-purple-300 to-blue-300 font-bold text-lg">
    PRESALE PHASES
  </span>
</div>





      {items.map((item) => (
        <div
          key={item.title}
          className="phase-gradient-border w-full mb-4 "
          style={{
            height: activeTitle === item.title ? `${item.activedHeight}px` : "60px",
            transition: "height 0.3s ease-in-out",
          }}
        >
          <div className="absolute inset-[1px] rounded-xl ">
            <button
              className="flex w-full items-center justify-between mt-4 text-white "
              aria-expanded={activeTitle === item.title}
              aria-controls={`phase-${item.title}`}
              onClick={() =>
                setActiveTitle(activeTitle === item.title ? "" : item.title)
              }
            >
              <span className="gradient-text font-semibold text-md md:text-lg ml-10 text-transparent bg-clip-text bg-gradient-to-r from-pink-300 via-purple-300 to-blue-300 font-bold text-lg">
                {item.title}
              </span>
              <FaAngleDown
                className={`transition-transform duration-300 ease-in-out mr-10 ${
                  activeTitle === item.title ? "rotate-180" : "rotate-0"
                }`}
                color="white"
              />
            </button>
            {activeTitle === item.title && (
              <>
                <div className="bg-gradient h-[1px] w-[95%] mx-auto mt-2"></div>
                <p
                  id={`phase-${item.title}`}
                  className="text-white/80 font-normal text-xs md:text-base px-4 md:px-10 mt-2"
                >
                  {item.info}
                </p>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Phase;
